import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-derivative-base',
  templateUrl: './derivative-base.component.html',
  styleUrls: ['./derivative-base.component.css']
})
export class DerivativeBaseComponent implements OnInit {

  fullscreen: boolean = false;

  derivative: string = "";

  constructor(private router: Router,
    private route: ActivatedRoute,
    private cdref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    let derivative = this.route.snapshot.params['derivative'];
  }

  clicktoggle() {
    this.fullscreen = !this.fullscreen;
    this.cdref.detectChanges();
  }

  hideSidebar() {
    this.fullscreen = true;
    this.cdref.detectChanges();
  }

  changeDerivative(event: { menuCode: string }) {
    this.derivative = event.menuCode;
    this.cdref.detectChanges();
  }


}
